import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/img/all-img/single-course-thumb.png'
import _imports_1 from '../../assets/img/all-img/author-1.png'
import _imports_2 from '../../assets/img/icon/ck.svg'
import _imports_3 from '../../assets/img/icon/laptop.svg'
import _imports_4 from '../../assets/img/icon/pencil.svg'
import _imports_5 from '../../assets/img/icon/wifi.svg'
import _imports_6 from '../../assets/img/icon/camera.svg'
import _imports_7 from '../../assets/img/icon/lock.svg'
import _imports_8 from '../../assets/img/icon/headphone.svg'
import _imports_9 from '../../assets/img/icon/file.svg'
import _imports_10 from '../../assets/img/all-img/ux.png'
import _imports_11 from '../../assets/img/icon/file2.svg'
import _imports_12 from '../../assets/img/icon/user2.svg'
import _imports_13 from '../../assets/img/icon/star.svg'
import _imports_14 from '../../assets/img/icon/like.svg'
import _imports_15 from '../../assets/img/social/fb.svg'
import _imports_16 from '../../assets/img/social/ln.svg'
import _imports_17 from '../../assets/img/social/twiiter.svg'
import _imports_18 from '../../assets/img/social/instra.svg'
import _imports_19 from '../../assets/img/social/youtube.svg'
import _imports_20 from '../../assets/img/all-img/cmnt-1.png'
import _imports_21 from '../../assets/img/all-img/cmnt-2.png'


const _hoisted_1 = { class: "single-course-area ptb-100" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-8 col-md-12" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "single-course-desc" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "single-course-image" }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_0,
        alt: "image"
      })
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "single-course-content" }, [
      /*#__PURE__*/_createElementVNode("p", { class: "course-catgy" }, "Data Science"),
      /*#__PURE__*/_createElementVNode("h2", null, "UI/UX Design and Graphics Learning Bootcamp 2023"),
      /*#__PURE__*/_createElementVNode("div", { class: "user-details" }, [
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_1,
          alt: "image"
        }),
        /*#__PURE__*/_createElementVNode("p", null, [
          /*#__PURE__*/_createElementVNode("span", null, "Trainer :"),
          /*#__PURE__*/_createTextVNode(),
          /*#__PURE__*/_createElementVNode("a", { href: "#" }, "Md Shamim Hossain")
        ]),
        /*#__PURE__*/_createElementVNode("p", { class: "course-date" }, [
          /*#__PURE__*/_createElementVNode("span", null, "Last Update:"),
          /*#__PURE__*/_createTextVNode(),
          /*#__PURE__*/_createElementVNode("a", { href: "#" }, "10 February, 2023")
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "course-tabs" }, [
      /*#__PURE__*/_createElementVNode("nav", null, [
        /*#__PURE__*/_createElementVNode("div", {
          class: "nav course-nav",
          id: "nav-tab",
          role: "tablist"
        }, [
          /*#__PURE__*/_createElementVNode("button", {
            class: "course-link active",
            id: "nav-overview-tab",
            "data-bs-toggle": "tab",
            "data-bs-target": "#nav-overview",
            type: "button",
            role: "tab",
            "aria-controls": "nav-overview",
            "aria-selected": "true"
          }, " Overview "),
          /*#__PURE__*/_createElementVNode("button", {
            class: "course-link",
            id: "nav-carriculum-tab",
            "data-bs-toggle": "tab",
            "data-bs-target": "#nav-carriculum",
            type: "button",
            role: "tab",
            "aria-controls": "nav-carriculum",
            "aria-selected": "false"
          }, " Carriculum "),
          /*#__PURE__*/_createElementVNode("button", {
            class: "course-link",
            id: "nav-instructor-tab",
            "data-bs-toggle": "tab",
            "data-bs-target": "#nav-instructor",
            type: "button",
            role: "tab",
            "aria-controls": "nav-instructor",
            "aria-selected": "false"
          }, " Instructor "),
          /*#__PURE__*/_createElementVNode("button", {
            class: "course-link",
            id: "nav-reviews-tab",
            "data-bs-toggle": "tab",
            "data-bs-target": "#nav-reviews",
            type: "button",
            role: "tab",
            "aria-controls": "nav-reviews",
            "aria-selected": "false"
          }, " Reviews ")
        ])
      ]),
      /*#__PURE__*/_createElementVNode("div", {
        class: "single-course-tab",
        id: "nav-tabContent"
      }, [
        /*#__PURE__*/_createElementVNode("div", {
          class: "overview-panel fade active show",
          id: "nav-overview",
          role: "tabpanel",
          "aria-labelledby": "nav-overview-tab"
        }, [
          /*#__PURE__*/_createElementVNode("div", { class: "overview-content cmb-30" }, [
            /*#__PURE__*/_createElementVNode("h3", { class: "course-desc-heading" }, "Course Description"),
            /*#__PURE__*/_createElementVNode("p", null, " This tutorial will help you learn quickly and thoroughly. Lorem ipsum, or lipsum as it sometimes known, is dummy text used in laying out print, graphic or web designs. Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Donec odio. Quisque volutpat mattis eros. "),
            /*#__PURE__*/_createElementVNode("p", null, " You’ll be exposed to principles and strategies, but, more importantly, you’ll learn how actually apply these abstract concepts by coding three different websites for three very different the audiences. Lorem ipsum is dummy text used in laying out print, graphic or web designs Lorem ipsum blinding shot chinwag knees. ")
          ]),
          /*#__PURE__*/_createElementVNode("div", { class: "overview-otp cmb-30" }, [
            /*#__PURE__*/_createElementVNode("h3", { class: "course-desc-heading" }, "What You will Learn?"),
            /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
              /*#__PURE__*/_createElementVNode("div", { class: "col-lg-6 col-md-12 col-sm-12" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "course-single-otp" }, [
                  /*#__PURE__*/_createElementVNode("img", {
                    src: _imports_2,
                    alt: "icon"
                  }),
                  /*#__PURE__*/_createElementVNode("p", null, " Learn how perspective works and how to incorporate your art ")
                ])
              ]),
              /*#__PURE__*/_createElementVNode("div", { class: "col-lg-6 col-md-12 col-sm-12" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "course-single-otp" }, [
                  /*#__PURE__*/_createElementVNode("img", {
                    src: _imports_2,
                    alt: "icon"
                  }),
                  /*#__PURE__*/_createElementVNode("p", null, " Learn how perspective works and how to incorporate your art ")
                ])
              ]),
              /*#__PURE__*/_createElementVNode("div", { class: "col-lg-6 col-md-12 col-sm-12" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "course-single-otp" }, [
                  /*#__PURE__*/_createElementVNode("img", {
                    src: _imports_2,
                    alt: "icon"
                  }),
                  /*#__PURE__*/_createElementVNode("p", null, " Learn how perspective works and how to incorporate your art ")
                ])
              ]),
              /*#__PURE__*/_createElementVNode("div", { class: "col-lg-6 col-md-12 col-sm-12" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "course-single-otp" }, [
                  /*#__PURE__*/_createElementVNode("img", {
                    src: _imports_2,
                    alt: "icon"
                  }),
                  /*#__PURE__*/_createElementVNode("p", null, " Learn how perspective works and how to incorporate your art ")
                ])
              ])
            ])
          ]),
          /*#__PURE__*/_createElementVNode("div", { class: "overview-extra" }, [
            /*#__PURE__*/_createElementVNode("h3", { class: "course-desc-heading" }, "Our Extra Fcilities!"),
            /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
              /*#__PURE__*/_createElementVNode("div", { class: "col-lg-4" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "extra-otp" }, [
                  /*#__PURE__*/_createElementVNode("img", {
                    src: _imports_3,
                    alt: "icon"
                  }),
                  /*#__PURE__*/_createElementVNode("p", null, "Computer/Mobile")
                ])
              ]),
              /*#__PURE__*/_createElementVNode("div", { class: "col-lg-4" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "extra-otp" }, [
                  /*#__PURE__*/_createElementVNode("img", {
                    src: _imports_4,
                    alt: "icon"
                  }),
                  /*#__PURE__*/_createElementVNode("p", null, "Paper & Pencil")
                ])
              ]),
              /*#__PURE__*/_createElementVNode("div", { class: "col-lg-4" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "extra-otp" }, [
                  /*#__PURE__*/_createElementVNode("img", {
                    src: _imports_5,
                    alt: "icon"
                  }),
                  /*#__PURE__*/_createElementVNode("p", null, "Internet Connect")
                ])
              ])
            ])
          ])
        ]),
        /*#__PURE__*/_createElementVNode("div", {
          class: "carriculum-panel fade",
          id: "nav-carriculum",
          role: "tabpanel",
          "aria-labelledby": "nav-carriculum-tab"
        }, [
          /*#__PURE__*/_createElementVNode("div", { class: "carriculum-content cmb-30" }, [
            /*#__PURE__*/_createElementVNode("h3", { class: "course-desc-heading" }, "Course Description"),
            /*#__PURE__*/_createElementVNode("ul", null, [
              /*#__PURE__*/_createElementVNode("li", null, [
                /*#__PURE__*/_createElementVNode("p", null, "Level Beginner")
              ]),
              /*#__PURE__*/_createElementVNode("li", null, [
                /*#__PURE__*/_createElementVNode("p", null, "12 Lectures")
              ]),
              /*#__PURE__*/_createElementVNode("li", null, [
                /*#__PURE__*/_createElementVNode("p", null, "Total: 5 Hours 56 Minutes 24 Seconds")
              ])
            ])
          ]),
          /*#__PURE__*/_createElementVNode("div", {
            class: "accordion",
            id: "accordionFlushExample"
          }, [
            /*#__PURE__*/_createElementVNode("div", { class: "accordion-item lesson-item" }, [
              /*#__PURE__*/_createElementVNode("h2", {
                class: "lesson-header",
                id: "flush-headingOne"
              }, [
                /*#__PURE__*/_createElementVNode("button", {
                  class: "accordion-button lession-button collapsed",
                  type: "button",
                  "data-bs-toggle": "collapse",
                  "data-bs-target": "#flush-collapseOne",
                  "aria-expanded": "false",
                  "aria-controls": "flush-collapseOne"
                }, [
                  /*#__PURE__*/_createTextVNode(" Introduction "),
                  /*#__PURE__*/_createElementVNode("span", null, "3 Lectures, 34:51 min")
                ])
              ]),
              /*#__PURE__*/_createElementVNode("div", {
                id: "flush-collapseOne",
                class: "accordion-collapse collapse lesson-collapse",
                "aria-labelledby": "flush-headingOne",
                "data-bs-parent": "#accordionFlushExample"
              }, [
                /*#__PURE__*/_createElementVNode("div", { class: "lesson-item-body" }, [
                  /*#__PURE__*/_createElementVNode("h3", null, "Intermediate Level"),
                  /*#__PURE__*/_createElementVNode("p", null, " This tutorial will help you learn quickly and thoroughly. Lorem ipsum is dummy text used in laying out print, graphic or web designs "),
                  /*#__PURE__*/_createElementVNode("h4", null, "2 Videos, 1 Audio, 1 Notebook"),
                  /*#__PURE__*/_createElementVNode("ul", { class: "lesson-item-list" }, [
                    /*#__PURE__*/_createElementVNode("a", { href: "#" }, [
                      /*#__PURE__*/_createElementVNode("li", null, [
                        /*#__PURE__*/_createElementVNode("div", { class: "lession-item-title" }, [
                          /*#__PURE__*/_createElementVNode("img", {
                            src: _imports_6,
                            alt: "icon"
                          }),
                          /*#__PURE__*/_createElementVNode("p", null, " Video: Getting Started and Introductions ")
                        ]),
                        /*#__PURE__*/_createElementVNode("div", { class: "lession-item-status" }, [
                          /*#__PURE__*/_createElementVNode("span", null, "Preview"),
                          /*#__PURE__*/_createElementVNode("img", {
                            src: _imports_7,
                            alt: "icon"
                          })
                        ])
                      ])
                    ]),
                    /*#__PURE__*/_createElementVNode("a", { href: "#" }, [
                      /*#__PURE__*/_createElementVNode("li", null, [
                        /*#__PURE__*/_createElementVNode("div", { class: "lession-item-title" }, [
                          /*#__PURE__*/_createElementVNode("img", {
                            src: _imports_8,
                            alt: "icon"
                          }),
                          /*#__PURE__*/_createElementVNode("p", null, "Audio: Connectig Throgh Technology")
                        ]),
                        /*#__PURE__*/_createElementVNode("div", { class: "lession-item-status" }, [
                          /*#__PURE__*/_createElementVNode("span", null, "Preview"),
                          /*#__PURE__*/_createElementVNode("img", {
                            src: _imports_7,
                            alt: "icon"
                          })
                        ])
                      ])
                    ]),
                    /*#__PURE__*/_createElementVNode("a", { href: "#" }, [
                      /*#__PURE__*/_createElementVNode("li", null, [
                        /*#__PURE__*/_createElementVNode("div", { class: "lession-item-title" }, [
                          /*#__PURE__*/_createElementVNode("img", {
                            src: _imports_9,
                            alt: "icon"
                          }),
                          /*#__PURE__*/_createElementVNode("p", null, "Video: Connectig Throgh Technology")
                        ]),
                        /*#__PURE__*/_createElementVNode("div", { class: "lession-item-status" }, [
                          /*#__PURE__*/_createElementVNode("img", {
                            src: _imports_7,
                            alt: "icon"
                          })
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            /*#__PURE__*/_createElementVNode("div", { class: "accordion-item lesson-item" }, [
              /*#__PURE__*/_createElementVNode("h2", {
                class: "lesson-header",
                id: "flush-headingTow"
              }, [
                /*#__PURE__*/_createElementVNode("button", {
                  class: "accordion-button lession-button collapsed",
                  type: "button",
                  "data-bs-toggle": "collapse",
                  "data-bs-target": "#flush-collapseTow",
                  "aria-expanded": "false",
                  "aria-controls": "flush-collapseTow"
                }, [
                  /*#__PURE__*/_createTextVNode(" Getting Started "),
                  /*#__PURE__*/_createElementVNode("span", null, "3 Lectures, 34:51 min")
                ])
              ]),
              /*#__PURE__*/_createElementVNode("div", {
                id: "flush-collapseTow",
                class: "accordion-collapse collapse lesson-collapse",
                "aria-labelledby": "flush-headingTow",
                "data-bs-parent": "#accordionFlushExample"
              }, [
                /*#__PURE__*/_createElementVNode("div", { class: "lesson-item-body" }, [
                  /*#__PURE__*/_createElementVNode("h3", null, "Intermediate Level"),
                  /*#__PURE__*/_createElementVNode("p", null, " This tutorial will help you learn quickly and thoroughly. Lorem ipsum is dummy text used in laying out print, graphic or web designs "),
                  /*#__PURE__*/_createElementVNode("h4", null, "2 Videos, 1 Audio, 1 Notebook"),
                  /*#__PURE__*/_createElementVNode("ul", { class: "lesson-item-list" }, [
                    /*#__PURE__*/_createElementVNode("a", { href: "#" }, [
                      /*#__PURE__*/_createElementVNode("li", null, [
                        /*#__PURE__*/_createElementVNode("div", { class: "lession-item-title" }, [
                          /*#__PURE__*/_createElementVNode("img", {
                            src: _imports_6,
                            alt: "icon"
                          }),
                          /*#__PURE__*/_createElementVNode("p", null, " Video: Getting Started and Introductions ")
                        ]),
                        /*#__PURE__*/_createElementVNode("div", { class: "lession-item-status" }, [
                          /*#__PURE__*/_createElementVNode("span", null, "Preview"),
                          /*#__PURE__*/_createElementVNode("img", {
                            src: _imports_7,
                            alt: "icon"
                          })
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        /*#__PURE__*/_createElementVNode("div", {
          class: "instructor-panel fade",
          id: "nav-instructor",
          role: "tabpanel",
          "aria-labelledby": "nav-instructor-tab"
        }, [
          /*#__PURE__*/_createElementVNode("div", { class: "single-instructor-content" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
              /*#__PURE__*/_createElementVNode("div", { class: "col-lg-5" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "instructor-img" }, [
                  /*#__PURE__*/_createElementVNode("img", {
                    src: _imports_10,
                    alt: "image"
                  })
                ])
              ]),
              /*#__PURE__*/_createElementVNode("div", { class: "col-lg-7" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "single-instructor-info" }, [
                  /*#__PURE__*/_createElementVNode("h2", null, "Daniel Smith"),
                  /*#__PURE__*/_createElementVNode("p", { class: "sub-title" }, "User Experience Designer"),
                  /*#__PURE__*/_createElementVNode("ul", null, [
                    /*#__PURE__*/_createElementVNode("li", null, [
                      /*#__PURE__*/_createElementVNode("img", {
                        src: _imports_11,
                        alt: "icon"
                      }),
                      /*#__PURE__*/_createElementVNode("span", null, "65+ Courses")
                    ]),
                    /*#__PURE__*/_createElementVNode("li", null, [
                      /*#__PURE__*/_createElementVNode("img", {
                        src: _imports_12,
                        alt: "icon"
                      }),
                      /*#__PURE__*/_createElementVNode("span", null, "2k+ Student Learned")
                    ]),
                    /*#__PURE__*/_createElementVNode("li", null, [
                      /*#__PURE__*/_createElementVNode("img", {
                        src: _imports_13,
                        alt: "icon"
                      }),
                      /*#__PURE__*/_createElementVNode("span", null, "547+ Reviews")
                    ]),
                    /*#__PURE__*/_createElementVNode("li", null, [
                      /*#__PURE__*/_createElementVNode("img", {
                        src: _imports_14,
                        alt: "icon"
                      }),
                      /*#__PURE__*/_createElementVNode("span", null, "4.9 Average Rating")
                    ])
                  ]),
                  /*#__PURE__*/_createElementVNode("ul", { class: "social-links" }, [
                    /*#__PURE__*/_createElementVNode("li", null, [
                      /*#__PURE__*/_createElementVNode("a", { href: "#" }, [
                        /*#__PURE__*/_createElementVNode("img", {
                          src: _imports_15,
                          alt: "icon"
                        })
                      ])
                    ]),
                    /*#__PURE__*/_createElementVNode("li", null, [
                      /*#__PURE__*/_createElementVNode("a", { href: "#" }, [
                        /*#__PURE__*/_createElementVNode("img", {
                          src: _imports_16,
                          alt: "icon"
                        })
                      ])
                    ]),
                    /*#__PURE__*/_createElementVNode("li", null, [
                      /*#__PURE__*/_createElementVNode("a", { href: "#" }, [
                        /*#__PURE__*/_createElementVNode("img", {
                          src: _imports_17,
                          alt: "icon"
                        })
                      ])
                    ]),
                    /*#__PURE__*/_createElementVNode("li", null, [
                      /*#__PURE__*/_createElementVNode("a", { href: "#" }, [
                        /*#__PURE__*/_createElementVNode("img", {
                          src: _imports_18,
                          alt: "icon"
                        })
                      ])
                    ]),
                    /*#__PURE__*/_createElementVNode("li", null, [
                      /*#__PURE__*/_createElementVNode("a", { href: "#" }, [
                        /*#__PURE__*/_createElementVNode("img", {
                          src: _imports_19,
                          alt: "icon"
                        })
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            /*#__PURE__*/_createElementVNode("div", { class: "single-instructor-desc" }, [
              /*#__PURE__*/_createElementVNode("p", null, " There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text. All the Lorem Ipsum generators on the Internet tend. ")
            ])
          ])
        ]),
        /*#__PURE__*/_createElementVNode("div", {
          class: "reviews-panel fade",
          id: "nav-reviews",
          role: "tabpanel",
          "aria-labelledby": "nav-reviews-tab"
        }, [
          /*#__PURE__*/_createElementVNode("div", { class: "lesseon-review-section" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "student-reating" }, [
              /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "col-lg-8 col-md-6" }, [
                  /*#__PURE__*/_createElementVNode("div", { class: "lession-review-items" }, [
                    /*#__PURE__*/_createElementVNode("ul", null, [
                      /*#__PURE__*/_createElementVNode("li", null, [
                        /*#__PURE__*/_createElementVNode("i", { class: "bx bxs-star" })
                      ]),
                      /*#__PURE__*/_createElementVNode("li", null, [
                        /*#__PURE__*/_createElementVNode("i", { class: "bx bxs-star" })
                      ]),
                      /*#__PURE__*/_createElementVNode("li", null, [
                        /*#__PURE__*/_createElementVNode("i", { class: "bx bxs-star" })
                      ]),
                      /*#__PURE__*/_createElementVNode("li", null, [
                        /*#__PURE__*/_createElementVNode("i", { class: "bx bxs-star disstar" })
                      ]),
                      /*#__PURE__*/_createElementVNode("li", null, [
                        /*#__PURE__*/_createElementVNode("i", { class: "bx bxs-star disstar" })
                      ])
                    ]),
                    /*#__PURE__*/_createElementVNode("div", { class: "progress-section" }, [
                      /*#__PURE__*/_createElementVNode("div", { class: "progress" }, [
                        /*#__PURE__*/_createElementVNode("div", {
                          class: "progress-bar psc02",
                          role: "progressbar",
                          "aria-valuenow": "67",
                          "aria-valuemin": "0",
                          "aria-valuemax": "67",
                          style: {"max-width":"67%"}
                        })
                      ])
                    ]),
                    /*#__PURE__*/_createElementVNode("div", { class: "progress-title" }, [
                      /*#__PURE__*/_createElementVNode("span", { class: "title" }, "67%")
                    ])
                  ]),
                  /*#__PURE__*/_createElementVNode("div", { class: "lession-review-items" }, [
                    /*#__PURE__*/_createElementVNode("ul", null, [
                      /*#__PURE__*/_createElementVNode("li", null, [
                        /*#__PURE__*/_createElementVNode("i", { class: "bx bxs-star" })
                      ]),
                      /*#__PURE__*/_createElementVNode("li", null, [
                        /*#__PURE__*/_createElementVNode("i", { class: "bx bxs-star" })
                      ]),
                      /*#__PURE__*/_createElementVNode("li", null, [
                        /*#__PURE__*/_createElementVNode("i", { class: "bx bxs-star" })
                      ]),
                      /*#__PURE__*/_createElementVNode("li", null, [
                        /*#__PURE__*/_createElementVNode("i", { class: "bx bxs-star disstar" })
                      ]),
                      /*#__PURE__*/_createElementVNode("li", null, [
                        /*#__PURE__*/_createElementVNode("i", { class: "bx bxs-star disstar" })
                      ])
                    ]),
                    /*#__PURE__*/_createElementVNode("div", { class: "progress-section" }, [
                      /*#__PURE__*/_createElementVNode("div", { class: "progress" }, [
                        /*#__PURE__*/_createElementVNode("div", {
                          class: "progress-bar psc02",
                          role: "progressbar",
                          "aria-valuenow": "67",
                          "aria-valuemin": "0",
                          "aria-valuemax": "67",
                          style: {"max-width":"67%"}
                        })
                      ])
                    ]),
                    /*#__PURE__*/_createElementVNode("div", { class: "progress-title" }, [
                      /*#__PURE__*/_createElementVNode("span", { class: "title" }, "67%")
                    ])
                  ]),
                  /*#__PURE__*/_createElementVNode("div", { class: "lession-review-items" }, [
                    /*#__PURE__*/_createElementVNode("ul", null, [
                      /*#__PURE__*/_createElementVNode("li", null, [
                        /*#__PURE__*/_createElementVNode("i", { class: "bx bxs-star" })
                      ]),
                      /*#__PURE__*/_createElementVNode("li", null, [
                        /*#__PURE__*/_createElementVNode("i", { class: "bx bxs-star" })
                      ]),
                      /*#__PURE__*/_createElementVNode("li", null, [
                        /*#__PURE__*/_createElementVNode("i", { class: "bx bxs-star" })
                      ]),
                      /*#__PURE__*/_createElementVNode("li", null, [
                        /*#__PURE__*/_createElementVNode("i", { class: "bx bxs-star disstar" })
                      ]),
                      /*#__PURE__*/_createElementVNode("li", null, [
                        /*#__PURE__*/_createElementVNode("i", { class: "bx bxs-star disstar" })
                      ])
                    ]),
                    /*#__PURE__*/_createElementVNode("div", { class: "progress-section" }, [
                      /*#__PURE__*/_createElementVNode("div", { class: "progress" }, [
                        /*#__PURE__*/_createElementVNode("div", {
                          class: "progress-bar psc02",
                          role: "progressbar",
                          "aria-valuenow": "67",
                          "aria-valuemin": "0",
                          "aria-valuemax": "67",
                          style: {"max-width":"67%"}
                        })
                      ])
                    ]),
                    /*#__PURE__*/_createElementVNode("div", { class: "progress-title" }, [
                      /*#__PURE__*/_createElementVNode("span", { class: "title" }, "67%")
                    ])
                  ]),
                  /*#__PURE__*/_createElementVNode("div", { class: "lession-review-items" }, [
                    /*#__PURE__*/_createElementVNode("ul", null, [
                      /*#__PURE__*/_createElementVNode("li", null, [
                        /*#__PURE__*/_createElementVNode("i", { class: "bx bxs-star" })
                      ]),
                      /*#__PURE__*/_createElementVNode("li", null, [
                        /*#__PURE__*/_createElementVNode("i", { class: "bx bxs-star" })
                      ]),
                      /*#__PURE__*/_createElementVNode("li", null, [
                        /*#__PURE__*/_createElementVNode("i", { class: "bx bxs-star" })
                      ]),
                      /*#__PURE__*/_createElementVNode("li", null, [
                        /*#__PURE__*/_createElementVNode("i", { class: "bx bxs-star disstar" })
                      ]),
                      /*#__PURE__*/_createElementVNode("li", null, [
                        /*#__PURE__*/_createElementVNode("i", { class: "bx bxs-star disstar" })
                      ])
                    ]),
                    /*#__PURE__*/_createElementVNode("div", { class: "progress-section" }, [
                      /*#__PURE__*/_createElementVNode("div", { class: "progress" }, [
                        /*#__PURE__*/_createElementVNode("div", {
                          class: "progress-bar psc02",
                          role: "progressbar",
                          "aria-valuenow": "67",
                          "aria-valuemin": "0",
                          "aria-valuemax": "67",
                          style: {"max-width":"67%"}
                        })
                      ])
                    ]),
                    /*#__PURE__*/_createElementVNode("div", { class: "progress-title" }, [
                      /*#__PURE__*/_createElementVNode("span", { class: "title" }, "67%")
                    ])
                  ]),
                  /*#__PURE__*/_createElementVNode("div", { class: "lession-review-items" }, [
                    /*#__PURE__*/_createElementVNode("ul", null, [
                      /*#__PURE__*/_createElementVNode("li", null, [
                        /*#__PURE__*/_createElementVNode("i", { class: "bx bxs-star" })
                      ]),
                      /*#__PURE__*/_createElementVNode("li", null, [
                        /*#__PURE__*/_createElementVNode("i", { class: "bx bxs-star" })
                      ]),
                      /*#__PURE__*/_createElementVNode("li", null, [
                        /*#__PURE__*/_createElementVNode("i", { class: "bx bxs-star" })
                      ]),
                      /*#__PURE__*/_createElementVNode("li", null, [
                        /*#__PURE__*/_createElementVNode("i", { class: "bx bxs-star disstar" })
                      ]),
                      /*#__PURE__*/_createElementVNode("li", null, [
                        /*#__PURE__*/_createElementVNode("i", { class: "bx bxs-star disstar" })
                      ])
                    ]),
                    /*#__PURE__*/_createElementVNode("div", { class: "progress-section" }, [
                      /*#__PURE__*/_createElementVNode("div", { class: "progress" }, [
                        /*#__PURE__*/_createElementVNode("div", {
                          class: "progress-bar psc02",
                          role: "progressbar",
                          "aria-valuenow": "67",
                          "aria-valuemin": "0",
                          "aria-valuemax": "67",
                          style: {"max-width":"67%"}
                        })
                      ])
                    ]),
                    /*#__PURE__*/_createElementVNode("div", { class: "progress-title" }, [
                      /*#__PURE__*/_createElementVNode("span", { class: "title" }, "67%")
                    ])
                  ])
                ]),
                /*#__PURE__*/_createElementVNode("div", { class: "col-lg-4 col-md-6" }, [
                  /*#__PURE__*/_createElementVNode("div", { class: "lession-total-review" }, [
                    /*#__PURE__*/_createElementVNode("h3", null, "4.9"),
                    /*#__PURE__*/_createElementVNode("ul", null, [
                      /*#__PURE__*/_createElementVNode("li", null, [
                        /*#__PURE__*/_createElementVNode("i", { class: "bx bxs-star" })
                      ]),
                      /*#__PURE__*/_createElementVNode("li", null, [
                        /*#__PURE__*/_createElementVNode("i", { class: "bx bxs-star" })
                      ]),
                      /*#__PURE__*/_createElementVNode("li", null, [
                        /*#__PURE__*/_createElementVNode("i", { class: "bx bxs-star" })
                      ]),
                      /*#__PURE__*/_createElementVNode("li", null, [
                        /*#__PURE__*/_createElementVNode("i", { class: "bx bxs-star disstar" })
                      ]),
                      /*#__PURE__*/_createElementVNode("li", null, [
                        /*#__PURE__*/_createElementVNode("i", { class: "bx bxs-star disstar" })
                      ])
                    ]),
                    /*#__PURE__*/_createElementVNode("p", null, "(2 Review)")
                  ])
                ])
              ])
            ]),
            /*#__PURE__*/_createElementVNode("div", { class: "student-review-section" }, [
              /*#__PURE__*/_createElementVNode("h4", null, "Reviews"),
              /*#__PURE__*/_createElementVNode("div", { class: "student-review-items" }, [
                /*#__PURE__*/_createElementVNode("img", {
                  src: _imports_20,
                  alt: "image"
                }),
                /*#__PURE__*/_createElementVNode("ul", null, [
                  /*#__PURE__*/_createElementVNode("li", null, [
                    /*#__PURE__*/_createElementVNode("i", { class: "bx bxs-star" })
                  ]),
                  /*#__PURE__*/_createElementVNode("li", null, [
                    /*#__PURE__*/_createElementVNode("i", { class: "bx bxs-star" })
                  ]),
                  /*#__PURE__*/_createElementVNode("li", null, [
                    /*#__PURE__*/_createElementVNode("i", { class: "bx bxs-star" })
                  ]),
                  /*#__PURE__*/_createElementVNode("li", null, [
                    /*#__PURE__*/_createElementVNode("i", { class: "bx bxs-star disstar" })
                  ]),
                  /*#__PURE__*/_createElementVNode("li", null, [
                    /*#__PURE__*/_createElementVNode("i", { class: "bx bxs-star disstar" })
                  ])
                ]),
                /*#__PURE__*/_createElementVNode("p", null, " There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration. "),
                /*#__PURE__*/_createElementVNode("h3", null, "Daniel Smith"),
                /*#__PURE__*/_createElementVNode("span", null, "Jan 24, 2023")
              ]),
              /*#__PURE__*/_createElementVNode("div", { class: "student-review-items" }, [
                /*#__PURE__*/_createElementVNode("img", {
                  src: _imports_21,
                  alt: "image"
                }),
                /*#__PURE__*/_createElementVNode("ul", null, [
                  /*#__PURE__*/_createElementVNode("li", null, [
                    /*#__PURE__*/_createElementVNode("i", { class: "bx bxs-star" })
                  ]),
                  /*#__PURE__*/_createElementVNode("li", null, [
                    /*#__PURE__*/_createElementVNode("i", { class: "bx bxs-star" })
                  ]),
                  /*#__PURE__*/_createElementVNode("li", null, [
                    /*#__PURE__*/_createElementVNode("i", { class: "bx bxs-star" })
                  ]),
                  /*#__PURE__*/_createElementVNode("li", null, [
                    /*#__PURE__*/_createElementVNode("i", { class: "bx bxs-star disstar" })
                  ]),
                  /*#__PURE__*/_createElementVNode("li", null, [
                    /*#__PURE__*/_createElementVNode("i", { class: "bx bxs-star disstar" })
                  ])
                ]),
                /*#__PURE__*/_createElementVNode("p", null, " There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration. "),
                /*#__PURE__*/_createElementVNode("h3", null, "Daniel Smith"),
                /*#__PURE__*/_createElementVNode("span", null, "Jan 24, 2023")
              ])
            ])
          ])
        ])
      ])
    ])
  ])
], -1)
const _hoisted_5 = { class: "col-lg-4 col-md-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CourseSidebar = _resolveComponent("CourseSidebar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_CourseSidebar)
        ])
      ])
    ])
  ]))
}